const { modMyPages: { restUrl }, } = window;
export const getAccessToken = () => fetch(`${restUrl}mod-my-pages/v1/access-token`, { method: 'POST' })
    .then((r) => r.json())
    .then(({ token, expires, decoded }) => ({
    token: token !== null && token !== void 0 ? token : '',
    expires: expires !== null && expires !== void 0 ? expires : 0,
    decoded: decoded !== null && decoded !== void 0 ? decoded : {},
}));
